import { useEffect } from "react";
import "./App.css";
import "./main.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { Dashboard } from "./components/Dashboard";
import { Card } from "./components/Card";
import keycloak from "./Keycloak";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { UserManagementView } from "./components/CardManagement";
import { DashboardSettingsView } from "./components/OperatorManagement";
import { CardPDF } from "./components/CardPDF";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let needsKeycloak = false;

if (window.location.href.includes("dashboard")) {
  needsKeycloak = true;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {needsKeycloak ? (
          <ReactKeycloakProvider authClient={keycloak}>
            <Routes>
              <Route path="/">
                <Route path="" element={<NotFoundView />} />
                <Route path="dashboard" element={<Dashboard />}>
                  <Route path="userManagement" element={<UserManagementView />} />
                  <Route path="settings" element={<DashboardSettingsView />} />
                </Route>
                <Route path="card" element={<Card />} />
              </Route>
            </Routes>
          </ReactKeycloakProvider>
        ) : (
          <Routes>
            <Route path="/">
              <Route path="" element={<NotFoundView />} />
              <Route path="dashboard" element={<Dashboard />}>
                <Route path="userManagement" element={<UserManagementView />} />
                <Route path="settings" element={<DashboardSettingsView />} />
              </Route>
              <Route path="card" element={<Card />} />
              <Route path="cardPDF" element={<CardPDF />} />
            </Route>
          </Routes>
        )}

        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

const NotFoundView = () => {
  const navigate = useNavigate();
  // Redirect to a different path
  useEffect(() => {
    if (window.location.pathname === "/") {
      navigate("/card"); // check how to redirect to the dashboard TODO
    }
  }, []);

  return <div>not found..</div>;
};

export default App;
